export default __webpack_public_path__ + "static/media/car9.d2f09060.jpg";